
import * as React from 'react'

const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 30
    const h = 30
    return (
        <svg width={w} height={h} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 7.5V15L20 17.5" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>



    )
}

export default SvgComponent
